import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    details: []
  },
  getters: {
    details: (state) => state.details,
  },
  actions: {
    rejectRequest({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseRequests/go-to-reject", id).then((r) => {
            resolve(r.data);
          })
      });
    },
    acceptRequest({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseRequests/go-to-confirm" , id)
          .then((r) => {
            // commit("setDetails", r.data);
            resolve(r.data);
          })
      });
    },
    createPurchaseRequest({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Procurements/api/PurchaseRequests", model).then((r) => {
            resolve(r.data);
          })
      });
    },
    editPurchaseRequest({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseRequests", model).then((r) => {
            resolve(r.data);
          })
      });
    },
    acceptPurchaseRequest({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseRequests/go-to-close", id).then((r) => {
            resolve(r.data);
          })
      });
    },
    fetchPurchaseRequest({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Procurements/api/PurchaseRequestsQuery/" + id)
          .then((r) => {
            // commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },

    CreateCheckInForReturnCheckOut({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/CheckInTransactions/for-return-checkout", model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    }
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    }
  }
};
